import axiosService from "../axios-util/axios-services";
import { Createchat } from "../../util/types";

/* 投稿 */
const getPostHistory = async (page: number) => {
  const params = { page: page }
  const response = await axiosService.get(`posts`, {params});
  return response.data;
};

const getPrivatePostHistory = async (page: number) => {
  const params = { page: page }
  const response = await axiosService.get(`posts/private_posts_history`, {params});
  return response.data;
};

const getCommentHistoryPosts = async (page: number) => {
  const params = {page: page}
  const response = await axiosService.get(`posts/comment_history`, {params});
  return response.data;
};

/**
 * Fetches posts that belong to a group
 * @param {string | number} group_id - the id of the group
 * @returns {Promise<AxiosResponse<any>>} - the response from the server
 */
const getGroupPosts = async (group_id: string | number, isPrivate: boolean, isPrivateUsers: boolean, page: number) => {
  const params = {
    member_group_id: group_id,
    is_private: isPrivate,
    is_private_group_user: isPrivateUsers,
    page: page
  }
  const response = await axiosService.get(`posts/member_group_posts`, {params});
  return response.data;
};

const getOpinionPosts = async (params: any) => {
  const response = await axiosService.get(`posts/opinion_posts`, {params});
  return response.data;
};

const getApprovedCategoryPosts = async (params: any) => {
  const response = await axiosService.get(`posts/category_posts`, {params});
  return response.data;
};

const getSinglePost = async (post_id: number) => {
  const response = await axiosService.get(`posts/${post_id}`);
  return response.data;
};

const editPost = async (id: number, body: any) => {
  const response = await axiosService.put(`posts/${id}`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

const getPostCommnets = async (postId: number) => {
  const response = await axiosService.get(`posts/${postId}/get_post_comments`);
  return response.data;
};

const cancelEvent = async (post_id: number) => {
  const response = await axiosService.patch(`posts/${post_id}/cancel`);

  return response;
};

const getSuggestionsInterval = async () => {
  const response = await axiosService.get(`posts/interval_activity_counts`);

  return response.data;
};

const getGroupEvents = async (id: any) => {
  const params = {
    member_group_id: id
  }
  const response = await axiosService.get(`posts/events`, {params});
  return response.data;
};

const getGroupEventsPagination = async (id: any, page : number) => {
  const params = {
    page: page,
    member_group_id: id
  }
  const response = await axiosService.get(`posts/events`, {params});
  return response.data;
};

const getUserPosts = async (userId: number, userType: string, page: number) => {
  const params = {
    creator_id: userId,
    creator_type: userType,
    page: page
  }
  const response = await axiosService.get(`posts/user_posts`, {params});
  return response.data;
};

const getDashboard3 = async () => {
  const response = await axiosService.get(`posts/dashboard`);

  return response?.data?.categories;
};
const getDashboard = async () => {
  const response = await axiosService.get(`posts/dashboard`);

  return response?.data?.categories;
};

const getSingleEventById = async (postId: number) => {
  const response = await axiosService.get(`posts/${postId}`);
  return response.data;
};

const getTopPosts = async () => {
  const params = {post_type: [0, 1]}
  const response = await axiosService.get(`posts/top_views`, {params});
  return response.data;
};

const getTopOpinionPosts = async () => {
  const params = {post_type: 1}
  const response = await axiosService.get(`posts/top_views`, {params});
  return response.data;
};

const getTopEveryOnesPosts = async () => {
  const params = {post_type: 0}
  const response = await axiosService.get(`posts/top_views`, {params});
  return response.data;
};

const savePost = async (body: any) => {
  const response = await axiosService.post(`posts`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
};

const likePost = async (post_id: number) => {
  let body = {
    post: {
      post_id: post_id,
      is_anonymous: false,
    },
  };
  const response = await axiosService.patch(`posts/${post_id}/like`, body);

  return response;
};

const dislikePost = async (post_id: number) => {
  let body = {
    post: {
      post_id: post_id,
      is_anonymous: false,
    },
  };
  const response = await axiosService.patch(`posts/${post_id}/delete_like`, body);

  return response;
};


const getPostImage = async (post_id: number, id: number): Promise<Blob> => {
  const res = await axiosService.get(`posts/${post_id}/images/${id}`, {
    responseType: 'blob'
  });
  return res.data;
};

/* 添付ファイル */
const getAttachment = async (post_id: number, id: number): Promise<Blob> => {
  const res = await axiosService.get(`posts/${post_id}/attachments/${id}`, {
    responseType: 'blob'
  });
  return res.data;
};

const requestAccessAttachment = async (post_id: number, id: number, user_id: number): Promise<string> => {
  const res = await axiosService.post(`posts/${post_id}/attachments/${id}/request`, {});
  return `${axiosService.defaults.baseURL}/public/attachments/${id}/file?attachment_access_request_id=${res.data.id}&user_id=${user_id}`;
};

/* 報告 */

const getPostReportList = async () => {
  const response = await axiosService.get(`post_reports`);
  return response.data
};

const createPostReport = async (postId: number, reason: string) => {
  const body = {
    post_id: postId,
    reason: reason
  }
  const response = await axiosService.post(`post_reports`, body);
  return response
};

/* コメント */

const replyComment = async (commentText: string, postId: number, parent_id: any, is_anonymous: string) => {
  let body = {
    comment: {
      post_id: postId,
      content: commentText,
      parent_id,
      is_anonymous: is_anonymous,
    },
  };

  const response = await axiosService.post(`comments`, body);

  return response.data;
};

const createComment = async (commentText: string, postId: number, is_anonymous: string, images: any) => {
  let body = {
    comment: {
      post_id: postId,
      content: commentText,
      images_attributes: images,
      is_anonymous: is_anonymous,
    },
  };

  const response = await axiosService.post(`comments`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

const editComment = async (commentId: number, commentText: string, postId: number, is_anonymous: string) => {
  let body = {
    comment: {
      post_id: postId,
      content: commentText,
      is_anonymous: is_anonymous,
    },
  };

  const response = await axiosService.put(`comments/${commentId}`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

const likeComment = async (comment_id: number) => {
  let body = {
    comment: {
      comment_id: comment_id,
      is_anonymous: false,
    },
  };
  const response = await axiosService.patch(`comments/${comment_id}/like`, body);

  return response;
};

const dislikeComment = async (comment_id: number) => {
  let body = {
    comment: {
      comment_id: comment_id,
      is_anonymous: false,
    },
  };
  const response = await axiosService.patch(`comments/${comment_id}/delete_like`, body);

  return response;
};

const getCommentImage = async (comment_id: number, id: number): Promise<Blob> => {
  const res = await axiosService.get(`comments/${comment_id}/images/${id}`, {
    responseType: 'blob'
  });
  return res.data;
};

/* グループユーザー */

const findMember = async (userId: any, groupId: any) => {
  const params = {
    member_group_id: groupId,
    user_id: userId,
  }
  const response = await axiosService.get(`member_group_users/find_member`, {params});
  return response.data;
};

const getMemberList = async (groupId: any) => {
  const params = {
    member_group_id: groupId,
    status: "approved",
  }
  const response = await axiosService.get(`member_group_users`, {params});
  return response.data;
};
const getMemberPendingList = async (groupId: any) => {
  const params = {
    member_group_id: groupId,
    status: "pending",
  }
  const response = await axiosService.get(`member_group_users`, {params});
  return response.data;
};

const createMemberGroupUsers = async (body: any) => {
  const response = await axiosService.post(`member_group_users`, body);
  return response.data;
};

const updateMemberGroupUsers = async (id: any, body: any) => {
  const response = await axiosService.put(`member_group_users/${id}`, body);
  return response.data;
};

const deleteMember = async (id: any) => {
  const response = await axiosService.delete(`member_group_users/${id}`);
  return response.data;
};

const canDeleteMembership = async (id: number) => {
  const response = await axiosService.get(`member_group_users/${id}/can_delete`);
  return response.data;
};

/* イベントユーザー */

const userEvents = async (userId: any) => {
  const params = {
    user_id: userId
  }
  const response = await axiosService.get(`post_event_users`, {params});
  return response.data;
};

const getCancelRequestsOfGroup = async (groupId: any) => {
  const params = {member_group_id: groupId}
  const response = await axiosService.get(`post_event_users/cancel_users`, {params});
  return response.data;
};

const getSinglePostEventUsers = async (id: number) => {
  const response = await axiosService.get(`post_event_users/${id}`);
  return response.data;
};

const addEventActivity = async (body: any) => {
  const response = await axiosService.post(`post_event_users`, body);
  return response.data;
};

const updatePostEventUsers = async (id: any, body: any) => {
  const response = await axiosService.put(`post_event_users/${id}`, body);
  return response.data;
};

const refundPostEventUsers = async (id: any) => {
  const response = await axiosService.patch(`post_event_users/${id}/refund`);
  return response.data;
};

const searchEventParticipant = async (eventId: number, user_id: number) => {
  const params = {
    post_event_id: eventId,
    user_id: user_id
  }
  const response = await axiosService.get(`post_event_users/search_event_participant`, {params});
  return response.data.post_event_user;
};

/* ユーザー */

const getDashboard2 = async () => {
  const response = await axiosService.get(`users/interval_activity_counts`);

  return response.data;
};

const getUserBalance = async (userId: number) => {
  const res = await axiosService.get(`users/${userId}/balance`);
  return res.data;
};

const getSingleUser = async (id: number) => {
  const response = await axiosService.get(`users/${id}`);
  return response.data;
};

const canCreateMemberGroup = async () => {
  const response = await axiosService.get(`users/can_create_member_group`);
  return response.data;
};

/* プライベート投稿を見られるユーザー */

const getPostUsers = async (post_id: number) => {
  const params = {post_id: post_id}
  const res = await axiosService.get(`post_private_users`, {params});
  return res.data;
};

const addUserInPost = async (postId: number, userId: number, privaterType: string) => {
  const res = await axiosService.post(`post_private_users`, {
    post_id: postId,
    privater_id: userId,
    privater_type: privaterType,
  });
  return res.data;
};

const removeUserInPost = async (postPrivateUserId: number) => {
  const res = await axiosService.delete(`post_private_users/${postPrivateUserId}`);
  return res.data;
};

/* イベント投稿 */

const getEventListByMemberGroup = async (memberGroupId: number) => {
  const params = {member_group_id: memberGroupId}
  const response = await axiosService.get(`post_events`, {params});
  return response.data;
};

const getMemberGroupFreeEvents = async () => {
  const response = await axiosService.get(`post_events/member_group_free_events`);
  return response.data;
};

const getSingleEvent = async (id: number) => {
  const response = await axiosService.get(`post_events/${id}`);
  return response.data;
};

/* チャット */

const showGroupChat = async (group_id: number | string) => {
  const  params = {
    member_group_id: group_id,
    chat_type: "group"
  }
  const response = await axiosService.get(`chats`, {params});
  return response.data;
};

const getChatList = async (groupId: any) => {
  const params = {member_group_id: groupId}
  const response = await axiosService.get(`chats`, {params});
  return response.data;
};

const getAllChatList = async () => {
  const response = await axiosService.get(`chats`);
  return response.data;
};

const getChatMessages = async (chatId: number) => {
  return await axiosService.get(`chats/${chatId}`);
};

const createChat = async (chatData: Createchat) => {
  return await axiosService.post(`chats`, chatData);
};

const addUserToChat = async (chatId: number | string, userId: number | string, authToken: string) => {
  try {
    const body = {
      user_id: userId,
      can_message: true
    }
    const headers = {
      auth_token: authToken,
      "Content-Type": "application/json",
    }
    const response = await axiosService.post(`chats/${chatId}/add_user`, body, {headers});
    return response.data;
  } catch (error) {
    console.error("Error managing chat:", error);
    throw error;
  }
};

const deleteUserChat = async (chatId: number, userId: number, authToken: string) => {
  const params = {user_id: userId }
  const headers = {
    auth_token: authToken,
    "Content-Type": "application/json",
  };
  const response = await axiosService.delete(`chats/${chatId}/remove_user`, {params, headers });
  return response.data;
};

const searchChatIdByParticipant = async (member_group_id: number | null, userId: number, authToken: string) => {
  const params = {
    member_group_id: member_group_id,
    user_id: userId
  }
  const response = await axiosService.get(`chats/search_chat_id_by_participant`, {
    params,
    headers: {
      auth_token: authToken,
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

const getLatestMessages = (chatId: number, lastMessageId: number, authToken: string) => {
  const params = {
    last_message_id: lastMessageId
  }
  return axiosService.get(`chats/${chatId}/messages`, {
    params,
    headers: {
      auth_token: authToken,
      "Content-Type": "application/json",
    },
  });
};

const sendMessage = async (content: string, auth_token: string, chatId: string) => {
  const body = {
    content: content
  }
  const headers = {
    auth_token: auth_token,
    "Content-Type": "application/json",
  };

  const response = await axiosService.post(`chats/${chatId}/messages`, body, { headers });
  return response.data;
};

/* ブロック */

const getBlocks = async (params?: any) => {
  const response = await axiosService.get(`blocks`, {params});
  return response.data
};

const createBlock = async (params: any) => {
  const body = { block: params }
  const response = await axiosService.post(`blocks`, body);
  return response.data;
};

const deleteBlock = async (blockId: number) => {
  const response = await axiosService.delete(`blocks/${blockId}`);
  return response
};

/* 画像 */

const getSampleImageList = async () => {
  const response = await axiosService.get(`sample_images`);
  return response.data.samples
};

const getSampleImage = async (id: number): Promise<File> => {
  const response = await axiosService.get(`sample_images/${id}/file`, {
    responseType: 'blob'
  });

  const disposition = response.headers['content-disposition'];
  let filename = id.toString();
  if (disposition && disposition.includes('filename=')) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = match[1];
    }
  }
  return new File([response.data], filename, { type: response.data.type });
};

/* グループ */

const getGroups = async () => {
  const response = await axiosService.get(`groups`);
  const groups = response.data.groups.map((item: { id: any; name: any; posts_count: any }) => {
    return {
      id: item.id,
      value: item.id,
      name: item.name,
      post_count: item.posts_count,
    };
  });

  return groups;
};

/* メンバーグループ */

/**
 * Fetches all groups that a user is a member of
 * @returns {Promise<AxiosResponse<any>>} - the response from the server
 */
const getMemberGroups = async (params: any) => {
  const response = await axiosService.get(`member_groups`, {params});
  return response.data;
};

const searchById = async (id: string, config: any) => {
  const params = {id: id}
  const response = await axiosService.get(`member_groups/search_by_id`, {params: params, ...config});
  return response.data;
};

const getMembersGroup = async (groupId: number) => {
  // const user = await userAuth.getUser();
  const response = await axiosService.get(`member_groups/${groupId}`);
  return response.data;
};

const createGroup = async (body: any) => {
  const response = await axiosService.post(`member_groups`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

const editGroup = async (id: any, body: any) => {
  const response = await axiosService.put(`member_groups/${id}`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

const getGroupBalance = async (groupId: number) => {
  const res = await axiosService.get(`member_groups/${groupId}/balance`);
  return res.data;
};

const closeMemberGroup = async (id: any) => {
  const response = await axiosService.post(`member_groups/${id}/close`);
  return response.data;
};

const canCloseMemberGroup = async (id: number) => {
  const response = await axiosService.get(`member_groups/${id}/can_close`);
  return response.data;
};

const getGroupBanner = async (groupId: number): Promise<Blob> => {
  const res = await axiosService.get(`member_groups/${groupId}/banner`, {
    responseType: 'blob'
  });
  return res.data;
};

const getGroupIcon = async (groupId: number): Promise<Blob> => {
  const res = await axiosService.get(`member_groups/${groupId}/icon`, {
    responseType: 'blob'
  });
  return res.data;
};

/* 支払い */

const getPaymentInfo = async (target: "User" | "MemberGroup", id: number, selectedYear: string, selectedMonth: string) => {
  const params = {
    target: target,
    id: id,
    target_month: `${selectedYear}-${selectedMonth}`,
  }
  const res = await axiosService.get(`payments`, {params});
  return res.data;
};

const createPayment = async (params: any) => {
  const body = {
    payment: params
  }
  const response = await axiosService.post(`payments`, body);
  return response.data;
};

const getGroupPayments = async (groupId: number) => {
  const params = { payee_id: groupId }
  const response = await axiosService.get(`payments/user_payments`, {params});
  return response.data;
};

const getMembershipFeeStatus = async (group_id: number, fee_type: string) => {
  const params = {
    "billing_cycle": fee_type,
    "member_group_id": group_id
  }
  const response = await axiosService.get(`payments/membership_fee_status`, {params});
  return response.data;
};

const getShopInfo = async (code: string) => {
  const params = {"qrcode": code}
  const res = await axiosService.get(`payments/shop_information`, {params});
  return res.data;
};

/* 立て替え精算 */

const getPaymentReimbursements = async (userId: number, selectedYear: string, selectedMonth: string) => {
  const params = {
    user_id: userId,
    target_month: `${selectedYear}-${selectedMonth}`,
  }
  const response = await axiosService.get(`reimbursements`, {params});
  return response.data;
};

const getPaymentGroupRejectedReimbursements = async (groupId: number) => {
  const params = { member_group_id: groupId }
  const response = await axiosService.get(`reimbursements/rejected_reimbursements`, {params});
  return response.data;
};

const getPaymentGroupReimbursements = async (groupId: number, selectedYear: string, selectedMonth: string) => {
  const params: Record<string, any> = {
    member_group_id: groupId,
    target_month: `${selectedYear}-${selectedMonth}`
  }
  const response = await axiosService.get(`reimbursements?`, {params});
  return response.data;
};

const paymentReimbursementsAdd = async (body: any) => {
  const response = await axiosService.post(`reimbursements`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

const approveReimbursement = async (id: any) => {
  const response = await axiosService.patch(`reimbursements/${id}/approve`);
  return response.data;
};

const rejectReimbursement = async (id: number, body: any) => {
  const response = await axiosService.patch(`reimbursements/${id}/reject`, body);
  return response.data;
};

const getReimbursementImage = async (id: number): Promise<Blob> => {
  const res = await axiosService.get(`reimbursements/${id}/image`, {
    responseType: 'blob'
  });
  return new Blob([res.data]);
};

/* 予定 */

const getPersonalPlans = async (user_id: number) => {
  const params = {user_id: user_id}
  const response = await axiosService.get(`personal_plans`, {params});
  return response.data;
};

const getSinglePersonalPlan = async (id: number) => {
  const response = await axiosService.get(`personal_plans/${id}`);
  return response.data;
};

const createPersonalPlan = async (body: any) => {
  const response = await axiosService.post(`personal_plans`, body);
  return response.data;
};

const editPersonalPlan = async (id: number, body: any) => {
  const response = await axiosService.put(`personal_plans/${id}`, body);
  return response.data;
};

/* カテゴリー */

const getCategory = async () => {
  const response = await axiosService.get(`categories`);
  const categories = response.data.categories.map((item: { id: any; name: any }) => {
    return {
      id: item.id,
      value: item.id,
      name: item.name,
    };
  });

  return categories;
};

/* 投票 */

const createVote = async (userId: number, voteOptionId: number, is_anonymous: boolean) => {
  let body = {
    vote: {
      user_id: userId,
      vote_option_id: voteOptionId,
      is_anonymous: is_anonymous,
    },
  };

  const response = await axiosService.post(`votes`, body);

  return response.data;
};

/* 意見 */

const saveSuggestion = async (body: any) => {
  const response = await axiosService.post(`suggestions`, body);
  return response;
};

/* 検索 */

const globalSearch = async (term: any, isPostSearch: boolean, cancelToken: any) => {
  const params = {
    term: term,
    post_search: isPostSearch,
  }
  const response = await axiosService.get(`search`, {params, cancelToken: cancelToken});
  return response.data;
};

const searchUsers = async (term: any, groupId: number | null, cancelToken: any, includeNavigator: boolean = false) => {
  const params = {
    term: term,
    member_group_id: groupId,
    include_navigator: includeNavigator
  }
  const response = await axiosService.get(`search_users`, {params, cancelToken: cancelToken});
  return response.data;
};

const appServices = {
  getPostHistory,
  getPrivatePostHistory,
  getCommentHistoryPosts,
  getGroupPosts,
  getOpinionPosts,
  getApprovedCategoryPosts,
  getSinglePost,
  editPost,
  getPostCommnets,
  cancelEvent,
  getSuggestionsInterval,
  getGroupEvents,
  getGroupEventsPagination,
  getUserPosts,
  getDashboard3,
  getDashboard,
  getSingleEventById,
  getTopPosts,
  getTopOpinionPosts,
  getTopEveryOnesPosts,
  savePost,
  likePost,
  dislikePost,
  getPostImage,
  getAttachment,
  requestAccessAttachment,
  getPostReportList,
  createPostReport,
  replyComment,
  createComment,
  editComment,
  likeComment,
  dislikeComment,
  getCommentImage,
  findMember,
  getMemberList,
  getMemberPendingList,
  createMemberGroupUsers,
  updateMemberGroupUsers,
  deleteMember,
  canDeleteMembership,
  userEvents,
  getCancelRequestsOfGroup,
  getSinglePostEventUsers,
  addEventActivity,
  updatePostEventUsers,
  refundPostEventUsers,
  searchEventParticipant,
  getDashboard2,
  getUserBalance,
  getSingleUser,
  canCreateMemberGroup,
  getPostUsers,
  addUserInPost,
  removeUserInPost,
  getMemberGroupFreeEvents,
  getEventListByMemberGroup,
  getSingleEvent,
  showGroupChat,
  getChatList,
  getAllChatList,
  getChatMessages,
  createChat,
  addUserToChat,
  deleteUserChat,
  searchChatIdByParticipant,
  getLatestMessages,
  sendMessage,
  getBlocks,
  createBlock,
  deleteBlock,
  getSampleImageList,
  getSampleImage,
  getGroups,
  getMemberGroups,
  searchById,
  getMembersGroup,
  createGroup,
  editGroup,
  getGroupBalance,
  closeMemberGroup,
  canCloseMemberGroup,
  getGroupBanner,
  getGroupIcon,
  getPaymentInfo,
  createPayment,
  getGroupPayments,
  getMembershipFeeStatus,
  getShopInfo,
  getPaymentReimbursements,
  getPaymentGroupRejectedReimbursements,
  getPaymentGroupReimbursements,
  paymentReimbursementsAdd,
  approveReimbursement,
  rejectReimbursement,
  getReimbursementImage,
  getPersonalPlans,
  getSinglePersonalPlan,
  createPersonalPlan,
  editPersonalPlan,
  getCategory,
  createVote,
  saveSuggestion,
  globalSearch,
  searchUsers,
};

export default appServices;
